import { ComputedShape, Shape } from "../types/zod";
import circle from "@turf/circle";
import destination from "@turf/destination";
import envelope from "@turf/envelope";
import transformRotate from "@turf/transform-rotate";
import { TPoint } from "../types/geojson";


export function generateShape(feature: Shape, excluded: boolean): ComputedShape {
	if (feature.geometry.type == "Point") {
		if (feature.properties.shapeType == "circle") {
			return {
				...circle(feature.geometry.coordinates, (feature.properties.width / 2) || 0, { "units": "meters", steps: 36 }),
				properties: {
					...feature.properties,
					__generatedGeometry: true,
					__excluded: excluded,
				},
				id: feature.id
			}
		} else if (feature.properties.shapeType == "rectangle") {
			const w = (feature.properties.width / 2) || 0;
			const h = (feature.properties.height / 2) || 0;
			const tl = destination(destination(feature as TPoint, w, 90, { units: "meters" }), h, 0, { units: "meters" })
			const br = destination(destination(feature as TPoint, w, -90, { units: "meters" }), h, 180, { units: "meters" })
			const poly = envelope({
				type: "FeatureCollection",
				features: [tl, br]
			});
			const rot = transformRotate(poly, feature.properties.rotation || 0) as ComputedShape;
			rot.properties = { ...feature.properties };
			rot.id = feature.id;
			rot.properties.__generatedGeometry = true;
			rot.properties.__excluded = excluded;
			return rot;
		} else if (feature.properties.shapeType == "image") {
			//keep as point
			const scaleFactor = feature.properties.worldSize ? 300 : 150;
			const loadImageWidth = Math.max(scaleFactor, scaleFactor * Math.round(feature.properties.width ?? 1));
			return {
				...feature,
				properties: {
					...feature.properties,
					__imageId: feature.properties.imageUrl ? `image-shape-${hashString(feature.properties.imageUrl)}` : null,
					__loadedWidth: Math.min(feature.properties.imageWidth ?? loadImageWidth, loadImageWidth),
					__excluded: excluded,
				},
			};
		}

	}
	return {
		...feature,
		properties: {
			...feature.properties,
			__excluded: excluded,
		},
	};
}

// Simple hash function for creating consistent image IDs
export function hashString(str: string): string {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		const char = str.charCodeAt(i);
		hash = ((hash << 5) - hash) + char;
		hash = hash & hash;
	}
	return Math.abs(hash).toString(36);
}